const modules = import.meta.glob('/src/changelog/*.md', {
  query: '?raw',
  import: 'default',
  eager: true,
}) as Record<string, string>

export interface ReleaseNote {
  slug: string
  date: string // ISO "YYYY-MM-DD" for sorting/formatting
  content: string
}

// Filenames follow "yyyyMMdd - title.md"
export const releaseNotes: ReleaseNote[] = Object.entries(modules)
  .map(([path, content]) => {
    const filename = path.split('/').pop()!.replace(/\.md$/, '')
    const match = filename.match(/^(\d{4})(\d{2})(\d{2})/)
    const date = match ? `${match[1]}-${match[2]}-${match[3]}` : ''
    return { slug: filename, date, content }
  })
  .sort((a, b) => b.date.localeCompare(a.date)) // newest first
